const getFontProperties = (style) => {
	const fontSize = parseFloat(style.getPropertyValue('font-size'))
	// TODO: check values for text font weights (normal, tiny, etc)
	const fontWeight = parseFloat(style.getPropertyValue('font-weight')) || 400
	const fontFamily = style.getPropertyValue('font-family')
	const lineHeight = parseFloat(style.getPropertyValue('line-height'))

	const letterSpacing =
		parseFloat(style.getPropertyValue('letter-spacing')) || 0

	return {
		fontSize,
		fontWeight,
		fontFamily,
		lineHeight,
		letterSpacing,
	}
}

export default getFontProperties
